document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hc-faq-trigger").forEach(trigger => {
    trigger.addEventListener("click", function () {
      let sectionValue = this.getAttribute("data-section");
      let relatedElements = document.querySelectorAll(`.hc-answer-question[data-section='${sectionValue}']`);
      this.classList.toggle('hc-opened');
      relatedElements.forEach(element => {
        if (element.style.display === "none" || element.style.display === "") {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        }
      });
    });
  });
});
function scrollToAndClickDataQ() {
  if (!document.querySelector('.hc-template-faq')) return;
  let hash = decodeURIComponent(window.location.hash.substring(1));
  if (!hash) return;
  const parts = hash.split('?');
  const primary = parts[0];
  const secondary = parts[1];
  const target = document.querySelector(`[data-q="${primary}"]`);
  if (!target) return;
  const scrollToWithOffset = (element) => {
    const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };
  scrollToWithOffset(target);
  setTimeout(() => {
    target.click();
    if (secondary) {
      const subTarget = document.querySelector(`[data-q-b="${secondary}"]`);
      if (subTarget) {
        setTimeout(() => {
          scrollToWithOffset(subTarget);
          setTimeout(() => {
            subTarget.click();
          }, 200);
        }, 400);
      }
    }
  }, 800);
}
window.addEventListener('DOMContentLoaded', scrollToAndClickDataQ);
window.addEventListener('hashchange', scrollToAndClickDataQ);
window.addEventListener('DOMContentLoaded', function () {
  var trigger = document.querySelector('.klaviyo_form_trigger');
  if (!trigger) return;
  trigger.addEventListener('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'VGaHqd']);
  });
});
(() => {
  const shouldRun = () =>
    document.body &&
    document.body.classList.contains('template-product') &&
    window.location.hash === '#learn';
  const getHeaderOffset = () => {
    const header =
      document.querySelector('[data-sticky-header]') ||
      document.querySelector('.site-header') ||
      document.querySelector('header');
    if (!header) return 0;
    const style = window.getComputedStyle(header);
    if (style.position !== 'fixed' && style.position !== 'sticky') return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().height));
  };
  const getTarget = () => {
    const main = document.querySelector('#MainContent');
    if (!main) return null;
    const sections = main.querySelectorAll('.shopify-section');
    if (sections.length < 2) return null;
    return sections[1] || null;
  };
  const ensureAnchor = (target) => {
    let anchor = document.getElementById('hc-learn-anchor');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.id = 'hc-learn-anchor';
      anchor.style.position = 'relative';
      anchor.style.width = '1px';
      anchor.style.height = '1px';
      anchor.style.pointerEvents = 'none';
      anchor.style.opacity = '0';
      target.parentNode.insertBefore(anchor, target);
    }
    return anchor;
  };
  const desiredTop = (anchor) => {
    const extra = 100;
    const offset = getHeaderOffset() + extra;
    const top = Math.round(anchor.getBoundingClientRect().top + window.pageYOffset - offset);
    return Math.max(0, top);
  };
  const lockScroll = (lockForMs) => {
    const start = Date.now();
    let lockedTo = null;
    let ourScroll = false;
    const originalScrollTo = window.scrollTo;
    const originalScrollBy = window.scrollBy;
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    const setOurScroll = (fn) => {
      ourScroll = true;
      try {
        fn();
      } finally {
        ourScroll = false;
      }
    };
    const restore = () => {
      window.scrollTo = originalScrollTo;
      window.scrollBy = originalScrollBy;
      Element.prototype.scrollIntoView = originalScrollIntoView;
    };
    const withinLock = () => (Date.now() - start) < lockForMs;
    window.scrollTo = function () {
      if (!withinLock()) return originalScrollTo.apply(window, arguments);
      if (ourScroll) return originalScrollTo.apply(window, arguments);
      if (lockedTo !== null) return originalScrollTo.call(window, { top: lockedTo });
      return originalScrollTo.apply(window, arguments);
    };
    window.scrollBy = function () {
      if (!withinLock()) return originalScrollBy.apply(window, arguments);
      if (ourScroll) return originalScrollBy.apply(window, arguments);
      if (lockedTo !== null) return originalScrollTo.call(window, { top: lockedTo });
      return;
    };
    Element.prototype.scrollIntoView = function () {
      if (!withinLock()) return originalScrollIntoView.apply(this, arguments);
      if (ourScroll) return originalScrollIntoView.apply(this, arguments);
      if (lockedTo !== null) return originalScrollTo.call(window, { top: lockedTo });
      return;
    };
    const setLockTop = (top) => {
      lockedTo = Math.max(0, Math.round(top));
    };
    setTimeout(restore, lockForMs + 50);
    return { setOurScroll, setLockTop };
  };
  const run = () => {
    if (!shouldRun()) return;
    if (typeof history !== 'undefined' && history.scrollRestoration) history.scrollRestoration = 'manual';
    if (window.pageYOffset > 24) return;
    const target = getTarget();
    if (!target) return;
    const anchor = ensureAnchor(target);
    const locker = lockScroll(1100);
    const go = () => {
      const top = desiredTop(anchor);
      locker.setLockTop(top);
      locker.setOurScroll(() => {
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    };
    go();
    let i = 0;
    const max = 18;
    const tick = () => {
      if (!shouldRun()) return;
      i += 1;
      go();
      if (i < max) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    setTimeout(go, 180);
    setTimeout(go, 420);
    setTimeout(() => {
      const top = desiredTop(anchor);
      locker.setLockTop(top);
      locker.setOurScroll(() => {
        window.scrollTo({ top: top });
      });
    }, 900);
  };
  window.addEventListener('DOMContentLoaded', run, { passive: true });
  window.addEventListener('pageshow', run, { passive: true });
  window.addEventListener('hashchange', () => {
    if (shouldRun()) run();
  }, { passive: true });
})();
(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const getHeaderOffset = () => {
    const header =
      document.querySelector('[data-sticky-header]') ||
      document.querySelector('.site-header') ||
      document.querySelector('header');
    const h = header ? header.getBoundingClientRect().height : 0;
    return Math.max(0, Math.round(h));
  };
  const openAccInSection = (section, id) => {
    const toggles = Array.from(section.querySelectorAll('[data-acc-toggle]'));
    const panels = Array.from(section.querySelectorAll('[data-acc-panel]'));
    toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
    panels.forEach(p => p.classList.remove('is-open'));
    const toggle = section.querySelector('[data-acc-toggle="' + id + '"]');
    const panel = section.querySelector('[data-acc-panel="' + id + '"]');
    if (!toggle || !panel) return null;
    toggle.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    return panel;
  };
  const findTabsSection = () => {
    const all = Array.from(document.querySelectorAll('.hc-tabs-section'));
    if (!all.length) return null;
    for (const s of all) {
      if (s.querySelector('.yotpo, #yotpo-app, .yotpo-main-widget, #yotpo-reviews-star-ratings-widget')) return s;
    }
    return all[0];
  };
  const scrollToTargetInside = (container) => {
    const pickTarget = () =>
      container.querySelector('#yotpo-app') ||
      container.querySelector('.yotpo-main-layout') ||
      container.querySelector('.yotpo-main-reviews-widget') ||
      container.querySelector('.yotpo') ||
      container;
    const doScroll = (el) => {
      const offset = getHeaderOffset() + 12;
      const top = Math.max(0, Math.round(el.getBoundingClientRect().top + window.pageYOffset - offset));
      window.scrollTo({ top, behavior: 'smooth' });
    };
    const targetNow = pickTarget();
    doScroll(targetNow);
    let tries = 0;
    const maxTries = 30;
    const tick = () => {
      tries += 1;
      const target = pickTarget();
      if (target && (target.id === 'yotpo-app' || target.classList.contains('yotpo-main-layout') || target.classList.contains('yotpo'))) {
        doScroll(target);
        return;
      }
      if (tries < maxTries) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const openFirstReviewsAndScroll = () => {
    if (!mq.matches) return;
    const section = findTabsSection();
    if (!section) return;
    const firstToggle = section.querySelector('[data-acc-toggle]');
    if (!firstToggle) return;
    const id = firstToggle.getAttribute('data-acc-toggle');
    const openedPanel = openAccInSection(section, id);
    if (!openedPanel) return;
    scrollToTargetInside(openedPanel);
  };
  const isStarsBadgeClick = (e) => {
    const el = e.target && e.target.closest && e.target.closest(
      '.yotpo-sr-bottom-line-button,' +
      '.yotpo-sr-bottom-line-summary,' +
      '.yotpo-reviews-summary-button,' +
      '#yotpo-reviews-star-ratings-widget button,' +
      '#yotpo-reviews-star-ratings-widget'
    );
    return !!el;
  };
  document.addEventListener('click', (e) => {
    if (!mq.matches) return;
    if (!isStarsBadgeClick(e)) return;
    e.preventDefault();
    openFirstReviewsAndScroll();
  }, true);
})();
